var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 11.0767C8.33887 11.0767 6.08057 8.7085 6.08057 5.66895C6.06836 2.69043 8.35107 0.371094 11 0.371094C13.6489 0.371094 15.9194 2.65381 15.9194 5.64453C15.9194 8.7085 13.6733 11.0767 11 11.0767ZM2.87012 22.4292C1.50293 22.4292 0.685059 21.7822 0.685059 20.708C0.685059 17.5586 4.66455 13.2373 11 13.2373C17.3232 13.2373 21.3149 17.5586 21.3149 20.708C21.3149 21.7822 20.4849 22.4292 19.1177 22.4292H2.87012Z",
    fill: "#3C1460"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.c21158a8e844993957a3d80b80f10352.svg";
export { ForwardRef as ReactComponent };